import { createApi } from "@reduxjs/toolkit/query/react";
import { appBaseQuery } from "../../services/baseQuery";
import { buildPagedListUrl } from "../../services/queryParams";

export const lineApi = createApi({
  reducerPath: "lineApi",
  baseQuery: appBaseQuery,
  tagTypes: ["Line"],
  endpoints: (builder) => ({
    getLines: builder.query({
      query: (params = {}) => buildPagedListUrl("line/", params),
      providesTags: ["Line"],
    }),
    addLine: builder.mutation({
      query: (newLine) => ({
        url: "line/",
        method: "POST",
        body: newLine,
      }),
      invalidatesTags: ["Line"],
    }),
    updateLine: builder.mutation({
      query: ({ uid, ...updatedLine }) => ({
        url: `line/${uid}`,
        method: "PUT",
        body: updatedLine,
      }),
      invalidatesTags: ["Line"],
    }),
    deleteLine: builder.mutation({
      query: (uid) => ({
        url: `line/${uid}`,
        method: "DELETE",
      }),
      invalidatesTags: ["Line"],
    }),
  }),
});

export const {
  useGetLinesQuery,
  useLazyGetLinesQuery,
  useAddLineMutation,
  useUpdateLineMutation,
  useDeleteLineMutation,
} = lineApi;
